import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918977772819?text=${encodedMessage}`;
  return (
    <div className='footer'>
      <div className="footer-container">
        <div className="footer-section">
          <div className="footer-logo">
            <img src="/logo.webp" alt="Reddy Anna" />
            <p>India's No.1 sports ID provider <br /> since 2010</p>
          </div>
        </div>
        <div className="footer-section">
          <h4>OUR SERVICES</h4>
          <ul>
            <li><a href="/sports-id">Sports ID</a></li>
            <li><a href="/blogs">Blogs</a></li>
            <li><a href="/platforms">Platforms</a></li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>COMPANY</h4>
          <ul>
            <li><a href="/about">About Us</a></li>
            <li><a href="/services">Services</a></li>
            <li><a href="/contact">Contact Us</a></li>
          </ul>
        </div>
        <div className="footer-section">
          <h4>LEGAL</h4>
          <ul>
            <li><a href="/terms-and-conditions">Terms and Conditions</a></li>
            <li><a href="/privacy-policy">Privacy Policy</a></li>
            <li><a href="/disclaimer">Disclaimer</a></li>
          </ul>
        </div>
        <img
          src="/legal.png"
          alt="Reddy Anna"
          style={{
            marginBottom: '10px',
            marginLeft: 'auto',
            marginRight: 'auto',
            width: '80%',
            height: '150px',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          }}
        />
        <p style={{
          color: 'red',
          marginLeft: 'auto',
          marginRight: 'auto',
        }} >To play, please ensure that you are at least 18 years old.</p>

      </div>
      <hr className='hr' />
      <div className="footer-bottomsection">
        <div className="footer-copyright">
          <p>&copy; 2024 <a href="/">Reddy Anna Book Official</a>. All rights reserved. Unauthorized reproduction or distribution of any content on this website is prohibited.</p>
        </div>
        <div className="footer-social">
          <a href={ContactLink}
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon" >
            <i className="fab fa-whatsapp"></i>
          </a>
          {/* <a href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon" >
            <i className="fab fa-facebook"></i>
          </a> */}
          <a href="https://www.instagram.com/reddyanna_book_official?igsh=MThoYnM5MTdybDRwYQ=="
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon" >
            <i className="fab fa-instagram"></i>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
